<template>
    <Handle type="target" :position="Position.Left" id="input" />
    <NodeBase title="Set Idle" icon="💤" color="#16a34a">
        <label>Idle state</label>
        <select :value="props.data.idleState ?? 'off'" @change="update('idleState', $event.target.value)">
            <option value="off">Off (wake screen)</option>
            <option value="short">Short</option>
            <option value="long">Long</option>
        </select>
    </NodeBase>
    <Handle type="source" :position="Position.Right" id="output" />
</template>

<script setup>
defineOptions({ inheritAttrs: false });
import { Handle, Position, useVueFlow } from '@vue-flow/core';
import NodeBase from './NodeBase.vue';

const props = defineProps({ id: String, data: Object });
const { updateNodeData } = useVueFlow();
const update = (key, val) => updateNodeData(props.id, { ...props.data, [key]: val });
</script>
